import InstrumentTable from './InstrumentTable';

export default InstrumentTable;
